import { useGetClientsQuery } from '../slice/api';

export const useClients = () => {
  const query = useGetClientsQuery();

  return {
    ...query,
    clients: query.data?.data.clients ?? [],
  };
};
